<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="31.498"
    height="25.433"
    viewBox="0 0 31.498 25.433"
  >
    <defs>
      <clipPath id="abilibee-svg">
        <rect
          width="31.498"
          height="25.433"
          fill="none"
        />
      </clipPath>
    </defs>
    <g clip-path="url(#abilibee-svg)">
      <path
        d="M18.167,52.733c-2.8,1.916-4,5.049-2.668,7s4.684,1.976,7.489.061,4-5.049,2.668-7-4.684-1.976-7.489-.061"
        transform="translate(-13.688 -46.968)"
        fill="#f4bb01"
      />
      <path
        d="M123.472,133.9c.952-3.493-2.395-7.447-7.475-8.832s-9.971.324-10.923,3.817,2.395,7.447,7.475,8.832,9.971-.324,10.923-3.817"
        transform="translate(-96.026 -114.033)"
        fill="#f4bb01"
      />
      <path
        d="M146.889,162.839s.473-6.869,7.045-7.876"
        transform="translate(-134.448 -141.838)"
        fill="#f4bb01"
      />
      <path
        d="M233.632,198.046s-2.286-4.621,1.585-7.754"
        transform="translate(-213.231 -174.175)"
        fill="#f4bb01"
      />
      <path
        d="M190.237,50.421c-.417,3.693,1.326,6.922,3.892,7.212s4.985-2.469,5.4-6.163-1.326-6.922-3.892-7.212-4.985,2.47-5.4,6.163"
        transform="translate(-174.068 -40.491)"
        fill="#f4bb01"
      />
      <path
        d="M206.7,94.588c-3.553,1.09-5.82,3.976-5.062,6.445s4.252,3.587,7.806,2.5,5.82-3.976,5.062-6.445-4.252-3.587-7.806-2.5"
        transform="translate(-184.424 -86.194)"
        fill="#f4bb01"
      />
      <path
        d="M30.528,19.491a6.08,6.08,0,0,1-1.667-.385,6.229,6.229,0,0,0-.228-2.2,8.427,8.427,0,0,0,1.53-1.492,5.315,5.315,0,0,0,1.13-4.9A5.315,5.315,0,0,0,27.612,7.1a8.12,8.12,0,0,0-1.3-.3,8.136,8.136,0,0,0-.56-1.306A5.315,5.315,0,0,0,21.713,2.5a5.314,5.314,0,0,0-4.605,2.013,9.547,9.547,0,0,0-2.146,4.849,11.763,11.763,0,0,0-1.541.281,4.988,4.988,0,0,0-.4-4.539A4.958,4.958,0,0,0,9.049,3.084,4.835,4.835,0,0,0,6.129.144c-1.53-.442-3.212.131-5,1.7A1.27,1.27,0,0,0,2.808,3.753c1.059-.93,1.986-1.346,2.61-1.17a1.875,1.875,0,0,1,.971.86A9.739,9.739,0,0,0,3.762,4.716,8.947,8.947,0,0,0,.407,8.8a5.028,5.028,0,0,0,.355,4.68,5.028,5.028,0,0,0,4.231,2.033h.057A8.129,8.129,0,0,0,7.7,15.043a7.1,7.1,0,0,0,1.849,5.833,13.261,13.261,0,0,0,6.635,4.03,14.676,14.676,0,0,0,3.847.526,12.033,12.033,0,0,0,3.625-.536c.972-.2,3.116-1.129,7.024-4.955a.264.264,0,0,0-.157-.451M21.428,5.03a2.922,2.922,0,0,1,2.148,1.777,10.887,10.887,0,0,0-1.675.372,10.135,10.135,0,0,0-3.9,2.191q-.227-.025-.454-.043c.53-2.574,2.2-4.485,3.877-4.3M2.86,12.046C1.942,10.7,3.011,8.306,5.2,6.814a6.508,6.508,0,0,1,3.535-1.2h.035a2.6,2.6,0,0,1,2.153.926c.918,1.344-.151,3.74-2.336,5.232s-4.805,1.616-5.723.272m8.619,7.172a4.491,4.491,0,0,1-1.206-4.035,4.5,4.5,0,0,1,3.107-2.872,8.58,8.58,0,0,1,1.5-.372,9.788,9.788,0,0,0,.271,1.6,9.287,9.287,0,0,0-2.782,3.329,11.714,11.714,0,0,0-.888,2.355m6.994,2.021a9.009,9.009,0,0,0,.233,1.574,12.6,12.6,0,0,1-1.85-.358,12.047,12.047,0,0,1-3.173-1.364l.024,0A8.289,8.289,0,0,1,16.2,15.955a6.5,6.5,0,0,0,.618.8,5.567,5.567,0,0,0,2.055,1.562,7.379,7.379,0,0,0-.4,2.92m7.746-1.71A4.5,4.5,0,0,1,23.113,22.4a8.72,8.72,0,0,1-1.769.41,5.549,5.549,0,0,1,.009-3.837,9.325,9.325,0,0,0,.95.049,10.57,10.57,0,0,0,3.086-.474c.314-.1.621-.207.92-.329a3.416,3.416,0,0,1-.09,1.309m-1.576-3.409c-2.829.868-5.677.11-6.218-1.655a2.963,2.963,0,0,1,.7-2.582,7.217,7.217,0,0,1,3.521-2.275,8.045,8.045,0,0,1,2.346-.36c1.906,0,3.484.748,3.872,2.015a2.963,2.963,0,0,1-.7,2.582,7.219,7.219,0,0,1-3.521,2.275"
        transform="translate(0 0)"
        fill="#291f00"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
import IconProps from '@/assets/ts/interfaces/IconProps'

withDefaults( defineProps<IconProps>(), {} )
</script>
